import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatRippleModule
} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {RouterModule} from '@angular/router';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSliderModule} from '@angular/material/slider';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatRadioModule} from '@angular/material/radio';
import {ALL_COMPONENTS} from './components/components';
import {ALL_INJECTABLES} from './components/injectables';
import {SETTINGS} from './models/settings/settings';
import * as de from './translations/de';
import {Platform} from '@angular/cdk/platform';
import {MaterialDateAdapter} from './services/material/materialDateAdapter';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';
import {ALL_DIRECTIVES} from './directives/directives';
import {ALL_PIPES} from './pipes/pipes';
import {TranslationService} from './services/translation.service';
import {CdkTableModule} from '@angular/cdk/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {ALL_SERVICES} from './services/services';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSortModule} from '@angular/material/sort';
import {NgxCsvParserModule} from 'ngx-csv-parser';
import {MatChipsModule} from '@angular/material/chips';
import {MatTreeModule} from '@angular/material/tree';
import {KeycloakLv1871Service} from './services/keycloak-lv1871.service';
import {RuntimeContext} from './models/platform/runtimeContext';

const MAT_MODULES = [
  MatIconModule,
  MatTreeModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatNativeDateModule,
  MatInputModule,
  MatSelectModule,
  MatSliderModule,
  MatTabsModule,
  MatToolbarModule,
  MatButtonModule,
  MatSidenavModule,
  MatProgressSpinnerModule,
  MatBottomSheetModule,
  MatRadioModule,
  MatAutocompleteModule,
  ReactiveFormsModule,
  MatDialogModule,
  MatSliderModule,
  MatSnackBarModule,
  MatProgressBarModule,
  MatRippleModule,
  MatButtonToggleModule,
  MatTooltipModule,
  MatCardModule,
  MatDividerModule,
  MatListModule,
  MatTableModule,
  CdkTableModule,
  MatPaginatorModule,
  MatSlideToggleModule,
  MatSortModule,
  MatChipsModule
];

@NgModule({
  declarations: [...ALL_COMPONENTS, ...ALL_DIRECTIVES, ...ALL_PIPES],
  exports: [
    ...ALL_COMPONENTS,
    ...ALL_DIRECTIVES,
    ...ALL_PIPES,
    ...MAT_MODULES,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ...MAT_MODULES,
    NgxCsvParserModule
  ],
})
export class CoreModule {

  constructor(private _translationService: TranslationService) {
    this._translationService.addTranslations('de', de.translations);
  }

  public static forRoot(settingsFactory): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ...ALL_INJECTABLES,
        ...ALL_SERVICES,
        MatIconRegistry,

        {provide: SETTINGS, useFactory: settingsFactory},
        {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
        {provide: DateAdapter, useClass: MaterialDateAdapter, deps: [MAT_DATE_LOCALE, Platform]}
      ],
    };
  }
}
